import addHours from 'date-fns/addHours';
import format from 'date-fns/format';
import { prettyCurrency } from 'lib/numUtils';

const formatDate = (date) => {
  let withAddedHours = addHours(new Date(date), 8);
  return format(new Date(withAddedHours), 'MM/dd/yyyy');
};

export const formatUserSales = (payload) => {
  const data = [...new Set(payload.map((n) => formatDate(n.report_date)))].map((n) => {
    const row = { report_date: n, count: 0 };
    const matches = payload.filter((o) => formatDate(o.report_date) === n);
    matches.forEach((o) => {
      row[o.user_name] = o.service_total_value;
      row[`${o.user_name}_tooltip_data`] = `${o.pipeline_count}/${prettyCurrency(parseInt(o.service_total_value, 10))}`;
    });
    return {
      ...row,
      count: matches.map((o) => parseFloat(o.pipeline_count)).reduce((a, b) => a + b, 0),
    };
  });
  const userKeys = [...new Set(payload.map((n) => n.user_name))];
  return {
    salesStackedUserKeys: userKeys.length > 0 ? userKeys : null,
    salesStackedUsersData: data.length > 0 ? data : null,
  };
};
